export default function useKeywordsAiAutoGridDefaultFilters() {
    return {
        kd: { filter: 30, filterType: "number", type: "lessThanOrEqual" },
        "pos2.traffic": { filter: 50, filterType: "number", type: "greaterThanOrEqual" },
        "pos4.traffic": { filter: 50, filterType: "number", type: "greaterThanOrEqual" },
        "pos6.traffic": { filter: 50, filterType: "number", type: "greaterThanOrEqual" },
        "pos8.traffic": { filter: 50, filterType: "number", type: "greaterThanOrEqual" },
        "pos10.traffic": { filter: 50, filterType: "number", type: "greaterThanOrEqual" },
    };
}
